module.exports = __webpack_public_path__ + "img/item-knowledgeBase.1f397dbf.svg";